import AuthGuard from '@/guard/auth'
import Navbar from '@/components/menu/Navbar'
import IamGuard from '@/guard/iam'
import { CorporateContextProvider } from '@/context/corporate'
import CorporateTasksPage from '@/components/pages/CorporateTasksPage'

function Corporate() {
	return (
		<AuthGuard>
			<IamGuard page='corporate'>
				<CorporateContextProvider>
					<div className='relative min-h-screen flex flex-col'>
						<Navbar></Navbar>
						<CorporateTasksPage></CorporateTasksPage>
					</div>
				</CorporateContextProvider>
			</IamGuard>
		</AuthGuard>
	)
}

export default Corporate
